module.exports = __webpack_public_path__ + "static/media/m_b_18.4a898b6f.png";